import React from 'react';
import { AppFormLayout, AppForm, AppFormPageProps, AppFormItemEnum, AppAction } from 'qcc'
import api, { MdmProject } from 'api'

export default class OrganEdit extends React.PureComponent<AppFormPageProps> {
  state = { parentProject: (this.props.extraData || { fullCode: '' }) as MdmProject }

  beforeSave = async (formData: MdmProject, appForm: AppForm) => {
    let { parentProject } = this.state;
    let item = appForm.getItem('full_code');
    let code = formData.code;
    let fullCode = formData.parentId === formData.organId ? code : parentProject.fullCode + '.' + code;
    item = { ...item, value: fullCode }
    appForm.onItemChange(item);
    return true
  }

  afterSave = () => {
    this.props.afterSave && this.props.afterSave();
    AppAction.closeDialog();
  }

  render() {
    let { formData, mode, id } = this.props;
    return (<AppFormLayout defaultButton mode={this.props.mode}>
      <AppFormLayout.Form>
        <AppForm loadingData={false} entity='mdm_project' mode={mode} keyValue={id} formData={...formData}
          beforeSave={this.beforeSave}
          afterSave={() => { this.afterSave() }}>
          <AppForm.Section labelWidth={100}>
            <AppForm.Item field='full_code' keyName='fullCode' itemType={AppFormItemEnum.hidden} dataType="string" />
            <AppForm.Item field='organ_id' keyName='organId' itemType={AppFormItemEnum.hidden} dataType="number" />
            <AppForm.Item field='parent_id' keyName='parentId' itemType={AppFormItemEnum.hidden} dataType="number" />
            <AppForm.Item field='name' itemType={AppFormItemEnum.input} label="名称" req unRepeat scopeField='parent_id' />
            <AppForm.Item field='code' itemType={AppFormItemEnum.input} label="项目编码" req unRepeat scopeField='parent_id' />
            <AppForm.Item field='md_id' keyName='mdId' itemType={AppFormItemEnum.input} label="主数据id" />
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/mdm/project/ProjectEdit.tsx